const moment = require("moment/moment");

function hasAvailability(serviceId, privacyType) {
    let service = currentSubproducts.find(function (subproduct) {
        return subproduct.service_id == serviceId;
    })

    const tourDate = $('#tour_date').val();

    if(!checkSubproductAvailability(service,tourDate,privacyType)) {
        return false;
    }
    return calculateCutOff(privacyType,service,tourDate);
}

function checkSubproductAvailability(service, tourDate, privacyType) {
    const availability = window.availabilityRawData;
    const privacyAvailability = availability[privacyType];
    const availabilityForDay = privacyAvailability
        ? privacyAvailability.find(day => day.date === tourDate)
        : undefined;

    if (!availabilityForDay) {
        return false;
    }

    const slots = getAvailabilitySlots(availabilityForDay);

    return slots.some(slot => slot.availability_service_ids.includes(service.availability_service_id));
}

function getAvailabilitySlots(availabilityForDay) {
    if (!availabilityForDay || !availabilityForDay.services.length) {
        return [];
    }
    return availabilityForDay.services[0].slots || [];
}

function calculateCutOff(privacyType, service, tourDate) {
    let cutOffTime;
    let reverseCutOffTime;
    if (privacyType === 'Private') {
        cutOffTime = service.cut_off_time_private;
        reverseCutOffTime = service.reverse_cut_off_time_private;

    } else {
        cutOffTime = service.cut_off_time_shared;
        reverseCutOffTime = service.reverse_cut_off_time_shared;
    }

    let cutOffTimeMoment = calculateCutOffTimeMoment(cutOffTime);
    let reverseCutOffTimeMoment = calculateCutOffTimeMoment(reverseCutOffTime);
    return calculateAvailabilities(tourDate, cutOffTimeMoment, reverseCutOffTimeMoment, true,privacyType);
}

function calculateCutOffTimeMoment(cutOffTime) {
    if (!cutOffTime || cutOffTime === '00:00:00') return null;

    let [hours, minutes, seconds] = cutOffTime.split(':').map(Number);
    let cutOffTimeInMilliseconds = hours * 3600000 + minutes * 60000 + seconds * 1000;

    return moment().add(cutOffTimeInMilliseconds, 'milliseconds');
}

function calculateAvailabilities(currentAvailability, cutOffTimeMoment, reverseCutOffTimeMoment, formatDates,privacyType) {
    let startDate = moment(currentAvailability, 'YYYY-MM-DD HH:mm:ss');

    if(!window.availabilityDay[privacyType].includes(currentAvailability))
        return false;

    let isAfterCutOff = !cutOffTimeMoment || startDate.isAfter(cutOffTimeMoment);
    let isBeforeReverseCutOff = !reverseCutOffTimeMoment || startDate.isBefore(reverseCutOffTimeMoment);

    return isAfterCutOff && isBeforeReverseCutOff;
}

function generateServiceLangsOptions(selectElement, privacyType) {
    selectElement.empty();

    let langsArray = [];
    if (privacyType === 'Private') {
        langsArray = currentServiceLangs.private;
    } else {
        langsArray = currentServiceLangs.group;
    }

    langsArray.forEach(langData => {
        const langId = langData.id;
        const langLabel = langData.label;
        const option = document.createElement('option');

        option.value = langId;
        option.textContent = langLabel;
        selectElement.append(option);
    });


}

module.exports = {hasAvailability, generateServiceLangsOptions};
